import React, { useEffect } from 'react';
import type { IsettingRateData } from '../../types/SettingRateData';
import { ContentWrapper } from './components/ContentWrapper';
import { InnerContent } from './components/InnerContent';

export interface IRatingBanner {
  ratingMsg: any;
  ratingData: any;
  settingRateData: IsettingRateData;
  trackingEvent?: (value: number, title: string) => void;
  recipeTitle: string;
  showCommentField?: boolean;
  showContactPageData?: boolean;
  contactPageData?: string;
  isPreparationStep?: boolean;
}

export const RatingBanner = ({
  ratingMsg,
  ratingData,
  settingRateData,
  trackingEvent,
  recipeTitle,
  showCommentField = false,
  showContactPageData = false,
  contactPageData = '',
  isPreparationStep = false,
}: IRatingBanner) => {
  useEffect(() => {
    const metaBallHigherParent = document.getElementById('metaball-container')?.firstElementChild;
    if (metaBallHigherParent) {
      metaBallHigherParent.classList.remove('top-5');
      metaBallHigherParent.classList.add('top-16');
    }
    const metaballHigher = document.getElementById('higher-blob');
    metaballHigher?.classList.remove('z-10');
    const metaballLower = document.getElementById('lower-blob');
    metaballLower?.classList.remove('z-10');

    const metaBallLower = document.getElementById('lower-blob');
    metaBallLower?.classList.add('-top-5');
  }, []);

  return (
    <ContentWrapper
      isPreparationStep={isPreparationStep}
      settingRateData={settingRateData}
      ratingMsg={ratingMsg}
    >
      <InnerContent
        ratingMsg={ratingMsg}
        ratingData={ratingData}
        settingRateData={settingRateData}
        trackingEvent={trackingEvent}
        recipeTitle={recipeTitle}
        showCommentField={showCommentField}
        showContactPageData={showContactPageData}
        contactPageData={contactPageData}
        isPreparationStep={isPreparationStep}
      />
    </ContentWrapper>
  );
};
